import API from "core/networks/API";
import { IApiResponseSuccess } from "core/networks/Interfaces";
import { AxiosResponse } from "axios";
import { call, put, takeLatest, take, cancel, fork, cancelled } from 'redux-saga/effects';
import {
  requestRecipeSuggestionSuccess,
  requestRecipeSuggestionError,

  fetchRecipeSuggestionSuccess,
  fetchRecipeSuggestionError,
  reloadRecipeSuggestionSuccess,

  fetchRecipeDetailSuccess,
  fetchRecipeDetailError,
  searchRecipeSuccess,
  searchRecipeError,
  searchAiRecipeError,
  searchAiRecipeSuccess,
} from './actions';
import {
  REQUEST_RECIPE_SUGGESTION_REQUEST,
  CANCEL_RECIPE_SUGGESTION_REQUEST,
  IRequestRecipeSuggestionResponse,
  RequestRecipeSuggestionRequestAction,

  FETCH_RECIPE_SUGGESTION_REQUEST,
  IFetchRecipeSuggestionResponse,
  IFetchRecipeSuggestionRequestAction,
  RELOAD_RECIPE_SUGGESTION_REQUEST,
  IReloadRecipeSuggestionRequestAction,

  FETCH_RECIPE_DETAIL_REQUEST,
  IFetchRecipeDetailResponse,
  IFetchRecipeDetailRequestAction,
  ISearchRecipeRequestAction,
  SEARCH_RECIPE_REQUEST,
  SEARCH_AI_RECIPE_REQUEST,
} from './types';
import {
  API_RECIPE_REQUEST,
  API_RECIPE_LIST,
  API_RECIPE_DETAIL,
  API_SEARCH_RECIPE,
  API_SEARCH_AI_RECIPE,
} from "../api";
import { route } from "core/router";

function* requestRecipeSuggestionRequest(action: RequestRecipeSuggestionRequestAction): any {
  try {
    const response: AxiosResponse<IApiResponseSuccess<IRequestRecipeSuggestionResponse>> = yield call(
      API.post,
      API_RECIPE_REQUEST,
      action?.payload
    );
    yield put(requestRecipeSuggestionSuccess(response.data.data));
  } catch (error: any) {
    console.log('error', error)
    yield put(requestRecipeSuggestionError(error?.response?.data as any));
  } finally {
    console.log('cancelled')
    if (yield cancelled()) {
      yield put(requestRecipeSuggestionError(null as any));
    }
  }
}

function* fetchRecipeSuggestionRequest(action: IFetchRecipeSuggestionRequestAction) {
  try {
    const {id, ...rest} = action.payload;
    const response: AxiosResponse<IApiResponseSuccess<IFetchRecipeSuggestionResponse>> = yield call(
      API.get,
      route(API_RECIPE_LIST, id),
      rest
    );
    yield put(fetchRecipeSuggestionSuccess(response.data.data));
  } catch (error) {
    yield put(fetchRecipeSuggestionError(error as Error));
  }
}

function* reloadRecipeSuggestionRequest(action: IReloadRecipeSuggestionRequestAction) {
  try {
    const {id, callback, ...rest} = action.payload;
    const response: AxiosResponse<IApiResponseSuccess<IFetchRecipeSuggestionResponse>> = yield call(
      API.get,
      route(API_RECIPE_LIST, id),
      rest
    );
    yield put(reloadRecipeSuggestionSuccess(response.data.data));
    callback?.(response.data.data)
  } catch (error) {
    yield put(fetchRecipeSuggestionError(error as Error));
  }
}

function* fetchRecipeDetail(action: IFetchRecipeDetailRequestAction) {
  try {
    const {id, recipe_request_id, callback} = action.payload;
    const response: AxiosResponse<IApiResponseSuccess<IFetchRecipeDetailResponse>> = yield call(
      API.get,
      route(API_RECIPE_DETAIL, id),
      {recipe_request_id}
    );
    yield put(fetchRecipeDetailSuccess(response.data.data));
    callback?.(response.data.data)
  } catch (error) {
    yield put(fetchRecipeDetailError(error as Error));
  }
}

function* searchRecipeRequest(action: ISearchRecipeRequestAction) {
  try {
    const response: AxiosResponse<IApiResponseSuccess<IFetchRecipeSuggestionResponse>> = yield call(
      API.get,
      route(API_SEARCH_RECIPE),
      action.payload
    );
    yield put(searchRecipeSuccess(response.data.data));
  } catch (error) {
    yield put(searchRecipeError(error as Error));
  }
}

function* requestSearchAiRecipeSuggestionRequest(action: ISearchRecipeRequestAction) {
  const param = {recipe_name:action.payload?.keyword}
  try {
    const response: AxiosResponse<IApiResponseSuccess<IFetchRecipeSuggestionResponse>> = yield call(
      API.post,
      API_SEARCH_AI_RECIPE,
      param
    );
    yield put(searchAiRecipeSuccess(response.data));
  } catch (error) {
    yield put(searchAiRecipeError(error as Error));
  }
}

export default function* IngredientSaga(): any {
  // yield takeLatest(REQUEST_RECIPE_SUGGESTION_REQUEST, requestRecipeSuggestionRequest);
  yield takeLatest(FETCH_RECIPE_SUGGESTION_REQUEST, fetchRecipeSuggestionRequest);
  yield takeLatest(RELOAD_RECIPE_SUGGESTION_REQUEST, reloadRecipeSuggestionRequest);
  yield takeLatest(FETCH_RECIPE_DETAIL_REQUEST, fetchRecipeDetail);
  yield takeLatest(SEARCH_RECIPE_REQUEST, searchRecipeRequest);
  yield takeLatest(SEARCH_AI_RECIPE_REQUEST, requestSearchAiRecipeSuggestionRequest);

  // cancel requestRecipeSuggestionRequest if call action CANCEL_RECIPE_SUGGESTION_REQUEST
  while (true) {
    const action = yield take(REQUEST_RECIPE_SUGGESTION_REQUEST);
    // const state: any = select(state => state.Recipes);
    // const request = state.request;
    // starts the requestRecipeSuggestionRequest
    const bgSyncTask: any = yield fork(requestRecipeSuggestionRequest as any, action)

    // wait for the user stop action
    yield take(CANCEL_RECIPE_SUGGESTION_REQUEST)
    // user clicked stop. cancel the requestRecipeSuggestionRequest
    // this will cause the forked requestRecipeSuggestionRequest task to jump into its finally block
    yield cancel(bgSyncTask)
  }
}
